import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "@/i18n/client";
import { ExecutivePeopleFormValues } from "@/screens/Customer/ExecutivePeople/form";
import Select from "@/components/Select";
import { executivePersonE24ReferenceType, executivePersonRegulationLevelReferenceType } from "@/constants/executivePerson";
import { getPersonNameWithDegrees } from "@/utils/customer";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { Contract, Process } from "@/types/contract";

interface ExecutivePersonProps {
  form: UseFormReturnType<ExecutivePeopleFormValues>;
  contract: Contract;
}

const priorityProps = {
  "data-filled": true,
  labelProps: {
    "data-floating": true,
  },
};

export const ExecutivePersonSelect = ({ form, contract }: ExecutivePersonProps) => {
  const enums = useContext(EnumerationsContext);
  const { t } = useTranslation("company");

  let filteredData = form.values.executivePeople.filter(e => e.referenceType !== executivePersonE24ReferenceType);
  if (contract.process === Process.NEW_POINT) {
    filteredData = filteredData.filter(e => e.referenceType !== executivePersonRegulationLevelReferenceType);
  }
  const selectData = filteredData.map(e => ({
    value: `${e.id}`,
    label: e.id
      ? getPersonNameWithDegrees(
          e.name,
          e.surname,
          e.degreeBeforeId,
          e.degreeBeforeId2,
          e.degreeAfterId,
          enums.degreeBefores,
          enums.degreeAfters
        )
      : t("newExecutivePerson"),
  }));

  return (
    <Select
      label={t("executivePerson")}
      priorityProps={priorityProps}
      data={selectData}
      onOptionSubmit={id => {
        form.setFieldValue("currentPersonId", id ? Number(id) : id);
      }}
      value={String(form.values.currentPersonId)}
    />
  );
};
